import { render, staticRenderFns } from "./SolicitudesCeder.vue?vue&type=template&id=155245d6&scoped=true"
import script from "./SolicitudesCeder.vue?vue&type=script&lang=js"
export * from "./SolicitudesCeder.vue?vue&type=script&lang=js"
import style0 from "./SolicitudesCeder.vue?vue&type=style&index=0&id=155245d6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "155245d6",
  null
  
)

export default component.exports